import axios from "axios";
import HTTPError from "./HTTPError";

/**
 * Base API class to handle all requests to the API
 *
 * @note You can pass in an options object to override the base_url and api_key when creating a new instance
 * @example
 * class MyApi extends BaseApi {
 *  constructor() {
 *   super("my_resource");
 * }
 * }
 */
class BaseApi {
  constructor(resource, options = {}) {
    this.resource = resource;
    this.base_url = "https://dev.iondeveloper.com/api/proposal/";
    this.api_key = process.env.REACT_APP_API_KEY;

    if (Object.hasOwn("base_url")) {
      this.base_url = options.base_url;
    }
    if (Object.hasOwn("api_key")) {
      this.api_key = options.api_key;
    }
   
    if (
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("staging")
    ) {
      this.base_url = "https://dev.iondeveloper.com/api/proposal-dev/";
    }
   
  }

  /**
   * Get the URL for the API
   *
   * @returns {String} The URL for the API
   */
  getUrl() {
    return this.#generateURL();
  }

  /**
   * Base request for our API
   *
   * @note You can pass in an options object to override the resource
   * @example
   * this.request({
   *  method: "get_disclosures",
   *  options: {
   *   override: {
   *    resource: "sungage",
   *  },
   * },
   */
  async request({ method, options, ...data }) {
    if (!this.resource) {
      throw new Error("resource is not defined");
    }
    const tmpUrl = this.base_url;
    // if (method === "get_tpo_pricing_v2") {
    //   this.base_url = "https://dev.iondeveloper.com/api/proposal-m/";
    // }

    const url = this.#generateURL(options);

    try {
      const res = await axios.post(url, { method, ...data });

      this.base_url = tmpUrl;
      this.status = res.status;
      this.statusText = res.statusText;
      this.url = url;

      return res.data;
    } catch (error) {
      throw new HTTPError(
        error.response.status,
        error.response.statusText,
        url
      );
    }
  }

  #generateURL = (options) => {
    if (this.api_key === null) {
      return `${this.base_url}${this.resource}`;
    }
    return `${this.base_url}${
      options?.override?.resource ?? this.resource
    }/?api_key=${this.api_key}`;
  };
}

export default BaseApi;
